import React, { useState } from 'react';
import {
  ButtonsContainer,
  CardContainer,
  CardContainer1,
  CorrectIcon,
  CrossButton,
  CrossIcon,
  DataText,
  DismissText,
  FeedbackButton,
  FeedbackButtonArrow,
  FeedbackButtonText,
  Frame1333,
  Frame1333Para,
  Frame1333Star,
  IconContainer,
  IconsContainer,
  ParaContainer,
  RequestedText,
  MarkedLiked,
  Tag,
  TagText,
  TagsAndTextContainer,
  UserNameBox,
  UserImage,
  TagsContainer,
  TextContainer,
  TextContainer1,
  WordsCount,
  WordsCountContainer,
  ShowMoreTextWrapper
} from './style';
import WhiteArrowRight from '../../static/img/Arrow-right-purple-24.svg';
import CloseCircle from '../../static/img/closecircle.svg';
import StyledButton from '../../components2/StyledButton';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptFeedbackRequest, declineFeedbackRequest } from '../../service';
import arrowRight from '../../static/img/arrowright.svg';
import { requestedTime } from '../../utils/requestedTime';
import { toast } from 'react-toastify';
import Toast from '../Toast';
import { Avatar } from '@boringer-avatars/react';
import { useCommunityTasks } from '../state/hooks';
import Loader from '../Loader';
import ShowMoreText from 'react-show-more-text';

const normalizeItem = (item) => {
  if (!item) return item;
  const tags = (item.tags || [])
    .map((tag) => {
      const raw = tag?.name;
      if (!raw || typeof raw !== 'string') return null;
      const trimmed = raw.trim();
      if (!trimmed) return null;
      if (trimmed.startsWith('{')) {
        try {
          const parsed = JSON.parse(trimmed);
          const name = parsed?.subjectName;
          return name ? { name } : null;
        } catch {
          return { name: trimmed };
        }
      }
      return { name: trimmed };
    })
    .filter(Boolean);
  return { ...item, title: item.title ?? '', tags };
};

function FeedbackDataComponent({ feedbackData, pathName }) {
  const queryClient = useQueryClient();
  const [expandedItems, setExpandedItems] = useState({});
  const {
    data: communityTasksData,
    isLoadingdata: isLoadingCommunityTasksData,
    setData: setCommunityTasksData,
    resetData: resetCommunityTasksData,
  } = useCommunityTasks();

  const toggleText = (itemIndex) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemIndex]: !prev[itemIndex]
    }));
  };

  const acceptMutation = useMutation({
    mutationFn: acceptFeedbackRequest,

    onSuccess: (data, variables) => {
      resetCommunityTasksData();
    },
    onSettled: () => {},
  });

  const declineMutation = useMutation({
    mutationFn: declineFeedbackRequest,

    onSuccess: (data, variables) => {
      const submissionId = variables;

      const updatedCommunityTasks = communityTasksData.filter(
        (n) => n.submissionId !== submissionId,
      );
      setCommunityTasksData(updatedCommunityTasks);
      queryClient.invalidateQueries('communityTasksData');
    },

    onSettled: () => {
      toast(<Toast message={'Feedback request dismissed'} />);
    },
  });

  if (isLoadingCommunityTasksData) {
    return <Loader />;
  }

  return (
    <>
      {feedbackData.map((item, index) => {
        const text = normalizeItem(item);
        return (
          <CardContainer key={index}>
            <TagsAndTextContainer>
              <UserNameBox>
                <UserImage>
                  <Avatar
                    title={false}
                    size={24}
                    variant="beam"
                    name={text?.authorName}
                    square={false}
                  />
                </UserImage>
                {text?.authorName}
              </UserNameBox>
              <RequestedText>
                {pathName.includes('/feedbackHistory')
                  ? 'Reviewed '
                  : 'Requested '}
                {requestedTime(
                  pathName.includes('/feedbackHistory')
                    ? text.reviewedAt
                    : text.requestedAt,
                )}
              </RequestedText>
            </TagsAndTextContainer>
            <TextContainer>
              <ShowMoreTextWrapper>
                <ShowMoreText
                  lines={2}
                  more="Show more"
                  less="Show less"
                  anchorClass="feedback-title-show-more-clickable"
                  expanded={expandedItems[index] || false}
                  truncatedEndingComponent={<span>...</span>}
                  onClick={() => toggleText(index)}
                  className="feedback-title-text"
                >
                  {text.title}
                </ShowMoreText>
              </ShowMoreTextWrapper>
              <WordsCountContainer>
                <TagsContainer>
                  {text.tags.map((tag, index) => (
                    <Tag key={index}>
                      <TagText>{tag.name}</TagText>
                    </Tag>
                  ))}
                </TagsContainer>
                <WordsCount>{text.wordCount} words</WordsCount>
              </WordsCountContainer>
            </TextContainer>
            <ButtonsContainer>
              {pathName.includes('/feedbackHistory') ? (
                <StyledButton
                  URL={text.url}
                  Text="Open"
                  Icon={WhiteArrowRight}
                  ColoredIcon={arrowRight}
                />
              ) : (
                <StyledButton
                  URL={text.url}
                  Text="Give Feedback"
                  Icon={WhiteArrowRight}
                  onAccept={() => acceptMutation.mutateAsync(text.id)}
                  ColoredIcon={arrowRight}
                />
              )}
              {!pathName.includes('/feedbackHistory') && (
                <CrossButton onClick={() => declineMutation.mutate(text.id)}>
                  <FeedbackButtonArrow src={CloseCircle} />
                  <DismissText>Dismiss</DismissText>
                </CrossButton>
              )}
            </ButtonsContainer>
          </CardContainer>
        );
      })}
    </>
  );
}

export default FeedbackDataComponent;
